import React from 'react';
import { UsersIcon, HomeIcon, ShoppingBagIcon, ShareIcon, BookOpenIcon, UserCheckIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
export function HomePage() {
  return <div className="w-full" data-id="element-90">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-emerald-600 to-emerald-800 text-white" data-id="element-91">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-id="element-92">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-93">
            <div data-id="element-94">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-95">
                Trust. Share. Thrive.
              </h1>
              <p className="text-xl mb-8" data-id="element-96">
                Kenya's premier host-to-host sharing platform transforming the
                short-term rental market.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-97">
                <CTAButton text="Join as a Host" href="#for-hosts" className="w-full sm:w-auto" data-id="element-98" />
                <CTAButton text="Partner as a Vendor" href="#for-vendors" variant="secondary" className="w-full sm:w-auto" data-id="element-99" />
              </div>
            </div>
            <div className="hidden md:block" data-id="element-100">
              <img src="https://images.unsplash.com/photo-1513584684374-8bab748fbf90?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Beautiful Kenyan apartment" className="rounded-lg shadow-xl" data-id="element-101" />
            </div>
          </div>
        </div>
      </section>
      {/* How It Works Section */}
      <section id="how-it-works" className="py-16 bg-white" data-id="element-102">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
          <div className="text-center mb-12" data-id="element-104">
            <h2 className="text-3xl font-bold mb-4" data-id="element-105">How UrbanWize Works</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-106">
              Our unique "Share" concept enables hosts to collaborate and thrive
              together in Kenya's growing short-term rental market.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-107">
            <div className="bg-gray-50 p-6 rounded-lg text-center" data-id="element-108">
              <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-109">
                <UsersIcon size={32} className="text-emerald-600" data-id="element-110" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-111">Guest Sharing</h3>
              <p className="text-gray-600" data-id="element-112">
                Connect with other hosts to share guests during overbookings or
                maintenance periods, ensuring no business is lost.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg text-center" data-id="element-113">
              <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-114">
                <BookOpenIcon size={32} className="text-emerald-600" data-id="element-115" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-116">Knowledge Sharing</h3>
              <p className="text-gray-600" data-id="element-117">
                Exchange local insights, market trends, and best practices with
                other experienced hosts in your city.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg text-center" data-id="element-118">
              <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-119">
                <ShoppingBagIcon size={32} className="text-emerald-600" data-id="element-120" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-121">Vendor Plugs</h3>
              <p className="text-gray-600" data-id="element-122">
                Access peer-vetted service providers for cleaning, maintenance,
                and other essential hospitality services.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Features Section */}
      <section id="features" className="py-16 bg-gray-50" data-id="element-123">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
          <div className="text-center mb-12" data-id="element-125">
            <h2 className="text-3xl font-bold mb-4" data-id="element-126">Platform Features</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-127">
              UrbanWize offers innovative tools designed specifically for
              Kenya's unique short-term rental market.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-128">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-129">
              <ShareIcon size={24} className="text-emerald-600 mb-4" data-id="element-130" />
              <h3 className="text-lg font-semibold mb-2" data-id="element-131">
                Mobile-First Platform
              </h3>
              <p className="text-gray-600" data-id="element-132">
                Access all features from your smartphone with our intuitive,
                mobile-optimized interface.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-133">
              <HomeIcon size={24} className="text-emerald-600 mb-4" data-id="element-134" />
              <h3 className="text-lg font-semibold mb-2" data-id="element-135">Multi-City Network</h3>
              <p className="text-gray-600" data-id="element-136">
                Connect with hosts across Nairobi, Kisumu, Nakuru and expanding
                to more Kenyan cities.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-137">
              <UserCheckIcon size={24} className="text-emerald-600 mb-4" data-id="element-138" />
              <h3 className="text-lg font-semibold mb-2" data-id="element-139">
                Peer-Vetted Services
              </h3>
              <p className="text-gray-600" data-id="element-140">
                Find trusted vendors recommended by other hosts in your
                community.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-141">
              <UsersIcon size={24} className="text-emerald-600 mb-4" data-id="element-142" />
              <h3 className="text-lg font-semibold mb-2" data-id="element-143">
                Booking Coordination
              </h3>
              <p className="text-gray-600" data-id="element-144">
                Seamlessly manage guest transfers and scheduling with other
                hosts.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-145">
              <ShoppingBagIcon size={24} className="text-emerald-600 mb-4" data-id="element-146" />
              <h3 className="text-lg font-semibold mb-2" data-id="element-147">Vendor Management</h3>
              <p className="text-gray-600" data-id="element-148">
                Schedule, track and pay service providers through one simple
                interface.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-149">
              <BookOpenIcon size={24} className="text-emerald-600 mb-4" data-id="element-150" />
              <h3 className="text-lg font-semibold mb-2" data-id="element-151">Community Insights</h3>
              <p className="text-gray-600" data-id="element-152">
                Access data-driven market insights and best practices from the
                UrbanWize community.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* For Hosts Section */}
      <section id="for-hosts" className="py-16 bg-white" data-id="element-153">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-155">
            <div data-id="element-156">
              <h2 className="text-3xl font-bold mb-4" data-id="element-157">For Hosts</h2>
              <p className="text-xl text-gray-600 mb-6" data-id="element-158">
                Join Kenya's most collaborative hosting community and transform
                your short-term rental business.
              </p>
              <div className="space-y-4 mb-8" data-id="element-159">
                <div className="flex items-start" data-id="element-160">
                  <div className="bg-emerald-100 p-2 rounded-full mr-4 mt-1" data-id="element-161">
                    <svg className="w-4 h-4 text-emerald-600" fill="currentColor" viewBox="0 0 20 20" data-id="element-162">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-163" />
                    </svg>
                  </div>
                  <div data-id="element-164">
                    <h4 className="font-semibold" data-id="element-165">Simple Onboarding</h4>
                    <p className="text-gray-600" data-id="element-166">
                      Create your profile, list your properties, and connect
                      with hosts in minutes.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-167">
                  <div className="bg-emerald-100 p-2 rounded-full mr-4 mt-1" data-id="element-168">
                    <svg className="w-4 h-4 text-emerald-600" fill="currentColor" viewBox="0 0 20 20" data-id="element-169">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-170" />
                    </svg>
                  </div>
                  <div data-id="element-171">
                    <h4 className="font-semibold" data-id="element-172">Revenue Growth</h4>
                    <p className="text-gray-600" data-id="element-173">
                      Increase occupancy rates through guest sharing and
                      referrals.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-174">
                  <div className="bg-emerald-100 p-2 rounded-full mr-4 mt-1" data-id="element-175">
                    <svg className="w-4 h-4 text-emerald-600" fill="currentColor" viewBox="0 0 20 20" data-id="element-176">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-177" />
                    </svg>
                  </div>
                  <div data-id="element-178">
                    <h4 className="font-semibold" data-id="element-179">Cost Reduction</h4>
                    <p className="text-gray-600" data-id="element-180">
                      Save on vendor services through group rates and community
                      recommendations.
                    </p>
                  </div>
                </div>
              </div>
              <CTAButton text="Join as a Host" href="#" data-id="element-181" />
            </div>
            <div className="mt-8 md:mt-0" data-id="element-182">
              <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Host using UrbanWize platform" className="rounded-lg shadow-lg" data-id="element-183" />
            </div>
          </div>
        </div>
      </section>
      {/* For Vendors Section */}
      <section id="for-vendors" className="py-16 bg-gray-50" data-id="element-184">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-186">
            <div className="order-2 md:order-1 mt-8 md:mt-0" data-id="element-187">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Vendor providing services" className="rounded-lg shadow-lg" data-id="element-188" />
            </div>
            <div className="order-1 md:order-2" data-id="element-189">
              <h2 className="text-3xl font-bold mb-4" data-id="element-190">For Vendors</h2>
              <p className="text-xl text-gray-600 mb-6" data-id="element-191">
                Partner with UrbanWize to connect with verified hosts seeking
                quality services across Kenya.
              </p>
              <div className="space-y-4 mb-8" data-id="element-192">
                <div className="flex items-start" data-id="element-193">
                  <div className="bg-emerald-100 p-2 rounded-full mr-4 mt-1" data-id="element-194">
                    <svg className="w-4 h-4 text-emerald-600" fill="currentColor" viewBox="0 0 20 20" data-id="element-195">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-196" />
                    </svg>
                  </div>
                  <div data-id="element-197">
                    <h4 className="font-semibold" data-id="element-198">Service Categories</h4>
                    <p className="text-gray-600" data-id="element-199">
                      Cleaning, maintenance, laundry, security, guest services,
                      and more.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-200">
                  <div className="bg-emerald-100 p-2 rounded-full mr-4 mt-1" data-id="element-201">
                    <svg className="w-4 h-4 text-emerald-600" fill="currentColor" viewBox="0 0 20 20" data-id="element-202">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-203" />
                    </svg>
                  </div>
                  <div data-id="element-204">
                    <h4 className="font-semibold" data-id="element-205">Verified Clients</h4>
                    <p className="text-gray-600" data-id="element-206">
                      Connect with pre-verified hosts managing multiple
                      properties.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-207">
                  <div className="bg-emerald-100 p-2 rounded-full mr-4 mt-1" data-id="element-208">
                    <svg className="w-4 h-4 text-emerald-600" fill="currentColor" viewBox="0 0 20 20" data-id="element-209">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-210" />
                    </svg>
                  </div>
                  <div data-id="element-211">
                    <h4 className="font-semibold" data-id="element-212">Simplified Payments</h4>
                    <p className="text-gray-600" data-id="element-213">
                      Get paid promptly through our secure payment system.
                    </p>
                  </div>
                </div>
              </div>
              <CTAButton text="Partner as a Vendor" href="#" data-id="element-214" />
            </div>
          </div>
        </div>
      </section>
      {/* About Us Section */}
      <section id="about" className="py-16 bg-white" data-id="element-215">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
          <div className="text-center mb-12" data-id="element-217">
            <h2 className="text-3xl font-bold mb-4" data-id="element-218">About UrbanWize</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-219">
              We're building Kenya's most collaborative hospitality ecosystem,
              connecting hosts and trusted service providers.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-220">
            <div data-id="element-221">
              <h3 className="text-2xl font-semibold mb-4" data-id="element-222">Our Vision</h3>
              <p className="text-gray-600 mb-6" data-id="element-223">
                UrbanWize aims to transform Kenya's short-term rental market by
                fostering collaboration between hosts and service providers. We
                believe that by sharing resources, knowledge, and opportunities,
                the entire hospitality ecosystem can thrive.
              </p>
              <h3 className="text-2xl font-semibold mb-4" data-id="element-224">Our Team</h3>
              <p className="text-gray-600" data-id="element-225">
                Founded by experienced hospitality professionals and tech
                innovators in Nairobi, our team combines local market expertise
                with cutting-edge platform development to create solutions
                specifically for the Kenyan short-term rental market.
              </p>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg shadow-sm" data-id="element-226">
              <h3 className="text-2xl font-semibold mb-6 text-center" data-id="element-227">
                Contact Us
              </h3>
              <form className="space-y-4" data-id="element-228">
                <div data-id="element-229">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-230">
                    Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-emerald-500 focus:border-emerald-500" data-id="element-231" />
                </div>
                <div data-id="element-232">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-233">
                    Email
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-emerald-500 focus:border-emerald-500" data-id="element-234" />
                </div>
                <div data-id="element-235">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-236">
                    Message
                  </label>
                  <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-emerald-500 focus:border-emerald-500" data-id="element-237"></textarea>
                </div>
                <button type="submit" className="w-full bg-emerald-600 text-white py-2 px-4 rounded-md hover:bg-emerald-700 transition-colors" data-id="element-238">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Blog/Resources Preview Section */}
      <section id="blog" className="py-16 bg-gray-50" data-id="element-239">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-240">
          <div className="text-center mb-12" data-id="element-241">
            <h2 className="text-3xl font-bold mb-4" data-id="element-242">Blog & Resources</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-243">
              Insights and tips for Kenya's short-term rental hosts and service
              providers.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-244">
            <div className="bg-white rounded-lg overflow-hidden shadow-sm" data-id="element-245">
              <img src="https://images.unsplash.com/photo-1606744837616-56c9a5c6a6eb?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Short-term rental trends" className="w-full h-48 object-cover" data-id="element-246" />
              <div className="p-6" data-id="element-247">
                <span className="text-sm text-emerald-600 font-medium" data-id="element-248">
                  Market Trends
                </span>
                <h3 className="text-xl font-semibold mt-2 mb-3" data-id="element-249">
                  Short-Term Rental Trends in Kenya for 2023
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-250">
                  Explore the latest trends shaping Kenya's growing short-term
                  rental market.
                </p>
                <a href="#" className="text-emerald-600 font-medium hover:text-emerald-700" data-id="element-251">
                  Read More →
                </a>
              </div>
            </div>
            <div className="bg-white rounded-lg overflow-hidden shadow-sm" data-id="element-252">
              <img src="https://images.unsplash.com/photo-1582582621959-48d27397dc69?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Host tips" className="w-full h-48 object-cover" data-id="element-253" />
              <div className="p-6" data-id="element-254">
                <span className="text-sm text-emerald-600 font-medium" data-id="element-255">
                  Hosting Tips
                </span>
                <h3 className="text-xl font-semibold mt-2 mb-3" data-id="element-256">
                  5 Ways to Enhance Guest Experience in Nairobi
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-257">
                  Practical tips to delight your guests and earn 5-star reviews.
                </p>
                <a href="#" className="text-emerald-600 font-medium hover:text-emerald-700" data-id="element-258">
                  Read More →
                </a>
              </div>
            </div>
            <div className="bg-white rounded-lg overflow-hidden shadow-sm" data-id="element-259">
              <img src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Vendor success" className="w-full h-48 object-cover" data-id="element-260" />
              <div className="p-6" data-id="element-261">
                <span className="text-sm text-emerald-600 font-medium" data-id="element-262">
                  Vendor Success
                </span>
                <h3 className="text-xl font-semibold mt-2 mb-3" data-id="element-263">
                  Building a Successful Cleaning Business for Short-Term Rentals
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-264">
                  How to grow your service business through the UrbanWize
                  platform.
                </p>
                <a href="#" className="text-emerald-600 font-medium hover:text-emerald-700" data-id="element-265">
                  Read More →
                </a>
              </div>
            </div>
          </div>
          <div className="text-center mt-10" data-id="element-266">
            <CTAButton text="View All Resources" href="#" variant="secondary" data-id="element-267" />
          </div>
        </div>
      </section>
      {/* Final CTA Section */}
      <section className="py-16 bg-emerald-700 text-white" data-id="element-268">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-269">
          <h2 className="text-3xl font-bold mb-6" data-id="element-270">
            Ready to Transform Your Hosting Business?
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto" data-id="element-271">
            Join Kenya's premier host-to-host sharing platform and start growing
            your short-term rental business today.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-272">
            <CTAButton text="Join as a Host" href="#" variant="primary" className="bg-white text-emerald-700 hover:bg-gray-100" data-id="element-273" />
            <CTAButton text="Partner as a Vendor" href="#" variant="secondary" className="bg-transparent text-white border-white hover:bg-emerald-600" data-id="element-274" />
          </div>
        </div>
      </section>
    </div>;
}